import Vue from "vue";

export default (highway) => {
  return Vue.$http
    .get(`catalogs/highway/filter/administrative/?highway=${highway}`)
    .then((response) => {
      return response.data.map((u) => {
        const getName = ({
          name = "",
          last_name = "",
          mothers_last_name = "",
          title = "",
        }) => {
          return `${title || ""} ${name || ""} ${last_name || ""} ${
            mothers_last_name || ""
          }`;
        };
        return {
          id: u.id,
          adminChiefName: getName(u),
        };
      });
    });
};



// WEBPACK FOOTER //
// ./src/services/sinister/fetchAdminChiefs.js